export enum EventName {
  PROFILE_MADE = 'profile_made',
}
